import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import type { ModalData, ModalDataForComponent, ModalNames, ModalWithoutData, PbDialogProps, TypedDialogInstance } from "~/types/modals";
import { ModalComponents } from "~/types/modals";

// Function overloads for type safety
export function useDynamicDialog<T extends ModalNames>(name: T, data: ModalData<T>, props?: PbDialogProps): DynamicDialogInstance;
export function useDynamicDialog<T extends ModalWithoutData>(name: ModalWithoutData, props?: PbDialogProps): DynamicDialogInstance;
export function useDynamicDialog(name: ModalNames.ADD_PHONE, data?: ModalData<ModalNames.ADD_PHONE>, props?: PbDialogProps): DynamicDialogInstance;
export function useDynamicDialog<T extends ModalNames>(name: T, data?: any, props?: PbDialogProps): DynamicDialogInstance {
    const nuxtApp = useNuxtApp();

    const defaultProps: PbDialogProps = {
                    modal: true,
                    closable: false,
                    dismissableMask: true,
                    pt: {
                        mask: 'bg-[#09090b80] modal-main',
                    },
    };

    const dialogOptions: any = {
        props: { ...defaultProps, ...props },
        onClose: props?.onClose,
    };

    if (data !== undefined) {
        dialogOptions.data = data;
    }

    return nuxtApp.$dialog.open(ModalComponents[name as keyof typeof ModalComponents](), dialogOptions);
}



export function getDialogRef<T extends keyof typeof ModalComponents>(_name: T): Ref<TypedDialogInstance<ModalDataForComponent<T>>> {
    return inject<Ref<TypedDialogInstance<ModalDataForComponent<T>>>>('dialogRef')!;
}
